import { Animate } from './modules/Animate'
import { Canvas } from './modules/Canvas'

new Animate()
new Canvas()

console.log('Zkoumáš zdroják? Respekt! 🤘🏻')
